export const PLACEHOLDER_IMAGE_MD5_HEX = new Set([
  '9d0846156dfccb7ad1948e86624507f6',
  '2a161873b153af24d7afa5c44388bc0a',
  'bb56d4d73ad04e8644591439d0ef742f',
  '2c5da82ca2afd73ad8ce05ec384e61fc',
  'c9d9c192a595a3bbd0cb483cf920d09b',
  '4e187d8b173bcf28aab7eb3098741bb9',
  '7d64192687c26e2bbde77ee52fc29607',
  '56745dc5b74d9ac581e5f88aab6aa479',
  '4c941970e693bef7a363304abcfba878',
  '5a709596317c66ad61cb017c1834a0b6',
  'ecd5d5a2078733a0f5aba42edd826c74',
]);

export const decodeImgproxySegment = (segment: string): string | null => {
  const trimmed = segment.replace(/\.webp$/i, '').trim();
  if (!trimmed) return null;
  try {
    let b64 = trimmed.replace(/-/g, '+').replace(/_/g, '/');
    const pad = b64.length % 4;
    if (pad) b64 += '='.repeat(4 - pad);
    if (typeof Buffer !== 'undefined') {
      return Buffer.from(b64, 'base64').toString('utf8');
    }
    if (typeof globalThis.atob === 'function') {
      return globalThis.atob(b64);
    }
    return null;
  } catch {
    return null;
  }
};

export const normalizeToCanonicalAssetUrl = (imageUrl: string): string => {
  if (!imageUrl.includes('cdn-img.')) return imageUrl;
  try {
    const m = imageUrl.match(/\/([^/]+)\.webp(?:\?|$)/i);
    if (!m?.[1]) return imageUrl;
    const decoded = decodeImgproxySegment(m[1]);
    if (!decoded || !decoded.startsWith('gs://')) return imageUrl;
    const objectPath = decoded.replace(/^gs:\/\/[^/]+\//, '');
    const { hostname } = new URL(imageUrl);
    const cdnHost = hostname.replace(/^cdn-img\./i, 'cdn.');
    return `https://${cdnHost}/${objectPath}`;
  } catch {
    return imageUrl;
  }
};

export const isComingSoonBySourceUrl = (imageUrl: string): boolean => {
  const lower = imageUrl.toLowerCase();
  if (
    lower.includes('/property/default/default_image') ||
    lower.includes('default_image.jpg') ||
    lower.includes('default_image.jpeg') ||
    lower.includes('default_image.webp')
  ) {
    return true;
  }
  if (lower.includes('cdn-img.') && lower.includes('.webp')) {
    const m = imageUrl.match(/\/([^/]+)\.webp(?:\?|$)/i);
    if (m?.[1]) {
      const decoded = decodeImgproxySegment(m[1]);
      if (decoded) {
        const d = decoded.toLowerCase();
        if (d.includes('/property/default/default_image') || d.includes('property/default/default_image')) {
          return true;
        }
      }
    }
  }
  return false;
};

export const isAllowedPlaceholderCheckHost = (hostname: string): boolean => {
  const h = hostname.toLowerCase();
  if (!h.includes('thrivestate')) return false;
  return h.startsWith('cdn.') || h.startsWith('cdn-img.');
};
